import React,{useState,useEffect} from 'react';
import { Container, Row, Col, Card, ListGroup, Button } from 'react-bootstrap';
import {getLoanApplicationDetailsApi,enquiry_details,get_user_details, get_master_data,updateLoanApplication,updateCustomerDetails,createAndupdateCustomerDetails} from "../Enums/api_constunts"
import { postMethod } from "../Helpers/services";
import _ from "lodash"
import HBar from "../Components/Bars/Bars";
const CustomerDetails = ({backAction,customer_data}) => {
  const [ loanFormDetails, setLoanFormDetails] = useState(null)
  const [setServiceTypes, setsetServiceTypes] =  useState([])
  const [otherIncomeList, setOtherIncomeList] =  useState([])
  const [otherObligationsList, setOtherObligationsList] =  useState([])
  const [professionList, setProfessionList] = useState([])
  const [professionSubList, setProfessionSubList] = useState([])
  
  
  const getMasterData = ()=>{
    let postData = {"categories":["md_lead_sources","md_profession_types","md_profession_sub_types","md_service_types","md_income_types","md_obligation_types"]};
    postData["categories"] = ["md_service_types"]
     postMethod(get_master_data,postData).then((res)=>{
        if(_.get(res,"result.md_service_types",[])){

        let lst =  _.get(res,"result.md_service_types",[]);
        lst = lst.filter((item)=>item.id!=1)
        setsetServiceTypes( lst.map((item)=>{ item["label"] =  item["name"];return item}))
        
      }
      if(_.get(res,"result.md_profession_types")){
        setProfessionList( _.get(res,"result.md_profession_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      }
      if(_.get(res,"result.md_profession_sub_types")){
        setProfessionSubList( _.get(res,"result.md_profession_sub_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      
      }
  })
  }
  useEffect(()=>{
    getMasterData()
  },[])

  const data_process = ()=>{
    if(loanFormDetails !=null && setServiceTypes.length>0 ){
      
      if(_.get(loanFormDetails,"loan_eligible_type")){
        let loan_eligible_type_details = setServiceTypes.find((item)=>item.id==loanFormDetails["loan_eligible_type"]);

        setLoanFormDetails({...loanFormDetails,"loan_eligible_type_details":loan_eligible_type_details})
      }
    }
    if(_.get(loanFormDetails,"otherIncome","")=="Yes"){

      try{
        let lst = []
        const jsonString = _.get(loanFormDetails,"other_income_list");            
        lst = JSON.parse(jsonString)
        setOtherIncomeList(lst)

      }catch(error){
        console.log(error)
      }

    }
    if(_.get(loanFormDetails,"Obligations","")=="Yes"){

      try{
        let lst = []
        const jsonString = _.get(loanFormDetails,"other_obligation");            
        lst = JSON.parse(jsonString)
        setOtherObligationsList(lst)

      }catch(error){
        console.log(error)
      }

    }
    // if(_.get(professionList,"length") >0){

    //   let professionType = _.find(professionList,(item)=>item["id"]==_.get(loanFormDetails,"profession_type_id"))
    //   if(professionType){
    //     setLoanFormDetails({...loanFormDetails,"professionType_details":professionType})
     

    //   }
    // }
    // if(_.get(professionSubList,"length") >0){

    //   let professionSubType = _.find(professionSubList,(item)=>item["id"]==_.get(loanFormDetails,"profession_sub_type_id"))
    //   if(professionSubType){
    //     setLoanFormDetails({...loanFormDetails,"profession_sub_type_details":professionSubType})
     

    //   }
    // }
    
    //setOtherObligationsList

  }
  useEffect(data_process,[loanFormDetails,setServiceTypes]);
  
  const getLoanApplicationDetails = ()=>{
    let postData ={"customer_id":customer_data["id"]}
    //getLoanApplicationDetailsApi
    postMethod(get_user_details,postData).then((res)=>{
      setLoanFormDetails(_.get(res,"result"))
      
      
    }).catch ((error)=>{
      //showToast("error",_.get(error, "message","Something went wrong!"))
     

    })

  }

  useEffect(()=>{
    getLoanApplicationDetails()
  },[customer_data])

  return (
    <div className="mt-3">
     
      <Row className="mb-4">
        <Col md={12}>
          {/* Contact Details */}
          <Card className="mb-4 subscriberDetails">
            {/* <Card.Header as="h5">Contact Details</Card.Header> */}
            <Card.Body className="bg-white">
              <ListGroup variant="flush">
                <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>First Name:</strong><br /> <span>{_.get(loanFormDetails,"applicant_details.first_name")}</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Last Name:</strong><br /> <span>{_.get(loanFormDetails,"applicant_details.last_name")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Date of Birth:</strong><br /> <span>{_.get(loanFormDetails,"applicant_details.date_of_birth")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Email:</strong><br /> <span>{_.get(loanFormDetails,"applicant_details.email")}</span>
                    </ListGroup.Item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>Mobile No:</strong><br /> <span>{_.get(loanFormDetails,"applicant_details.mobile_no")}</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Enquiry:</strong><br /> <span>{
                      _.get(loanFormDetails,"detail_of_service.name")?_.get(loanFormDetails,"detail_of_service.name"): _.get(loanFormDetails,"applicant_details.detail_of_service.name")?_.get(loanFormDetails,"applicant_details.detail_of_service.name"):''
                      }</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Amount:</strong><br /> <span>{_.get(loanFormDetails,"loanAmount")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Lead Source:</strong><br /> <span>{_.get(loanFormDetails,"lead_sourse_details.name")}</span>
                    </ListGroup.Item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>Profession Type:</strong><br /> <span>
                      
                    {_.get(loanFormDetails,"profession_details.name")=="SENP"?"Self Employed Non Professional":_.get(loanFormDetails,"profession_details.name")=="SEP"?"Self Employed Professional":_.get(loanFormDetails,"profession_details.name")}
                     
                      
                      </span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Eligible:</strong><br /> <span>{_.get(loanFormDetails,"eligible")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Eligible Type:</strong><br /> <span>{_.get(loanFormDetails,"loan_eligible_type_details.name")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Eligible Amount:</strong><br /> <span>{_.get(loanFormDetails,"loan_eligible_amount")} </span>
                    </ListGroup.Item>
                  </div>
                </div>
                <div class="row">
                <div class="col-md-3">
                    <ListGroup.Item>
                    <strong>Proposed EMI:</strong><br /> <span>{_.get(loanFormDetails,"proposed_emi")}</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                    <strong>Foir:</strong><br /> <span>{_.get(loanFormDetails,"fdir")}</span>
                  </ListGroup.Item>
                  </div>
                  
                  
                  {/* {_.get(loanFormDetails,"sepType") && _.get(loanFormDetails,"profession_details.name")!="SEP" && <div class="col-md-3"><ListGroup.Item>
                    <strong>Profession:</strong><br /> <span>{_.get(loanFormDetails,"sepType")}</span>
                  </ListGroup.Item>
                  </div>
                  } */}

                  {
                 _.get(loanFormDetails,"profession_sub_type_details.name") && <div class="col-md-3"><ListGroup.Item>
                    <strong>Profession Sub Type:</strong><br /> <span>{_.get(loanFormDetails,"profession_sub_type_details.name")}</span>
                  </ListGroup.Item>
                  </div>
                  }
                  {_.get(loanFormDetails,"sepType") && _.get(loanFormDetails,"profession_details.name")!="SEP" && <div class="col-md-3"><ListGroup.Item>
                    <strong>Profession:</strong><br /> <span>{_.get(loanFormDetails,"income_type_details.name")}</span>
                  </ListGroup.Item>
                  </div>
                  }
                  
                  
                  
                  {/*
                  otherObligationsList otherIncomeList
                  */}
                                   
                 
                  
                </div>
              </ListGroup>
            </Card.Body>
          </Card>

          {_.get(otherIncomeList,"length",0)>0&&<Card className="mb-4 subscriberDetails">
             <Card.Body className="bg-white">
              <ListGroup variant="flush">
              {_.get(otherIncomeList,"length",0)>0&&<>
                    
                    <div class="row">
                    <HBar label="Other Income" />
                    

                    
                   {
                    otherIncomeList.map((item)=>{

                      return (<>
                       <div class="col-md-6"><ListGroup.Item>
                    <strong>Income Type:</strong><br /> <span>{_.get(item,"incomeType")}</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-6"><ListGroup.Item>
                    <strong>Income:</strong><br /> <span>{_.get(item,"amount")}</span>
                  </ListGroup.Item>
                  </div>

                      
                      </>)

                    })
                   }

                    
                    </div>
                  </>}

              </ListGroup>
            </Card.Body>
          </Card>
          }
          {_.get(otherObligationsList,"length",0)>0&&<Card className="mb-4 subscriberDetails">
             <Card.Body className="bg-white">
              <ListGroup variant="flush">
              {_.get(otherObligationsList,"length",0)>0&&<>
                    
                    <div class="row">
                    <HBar label="Obligations" />
                    


                    
                   {
                    otherObligationsList.map((item)=>{

                      return (<>
                      
                       <div class="col-md-2"><ListGroup.Item>
                         <strong>Obligation Type:</strong><br /> <span>{_.get(item,"obligationType")}</span>
                         </ListGroup.Item>
                        </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>Loan Amount:</strong><br /> <span>{_.get(item,"loanAmount")}</span>
                      </ListGroup.Item>
                      </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>Total tenure:</strong><br /> <span>{_.get(item,"totaltenure")}</span>
                      </ListGroup.Item>
                      </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>Bank:</strong><br /> <span>{_.get(item,"bankName")}</span>
                      </ListGroup.Item>
                      </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>Present OS:</strong><br /> <span>{_.get(item,"presentOS")}</span>
                      </ListGroup.Item>
                      </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>Balance Terms:</strong><br /> <span>{_.get(item,"balanceTerm")}</span>
                      </ListGroup.Item>
                      </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>ROI:</strong><br /> <span>{_.get(item,"roi")}%</span>
                      </ListGroup.Item>
                      </div>
                      <div class="col-md-2"><ListGroup.Item>
                        <strong>Emi Amount (Per Month):</strong><br /> <span>{_.get(item,"emiAmount")}</span>
                      </ListGroup.Item>
                      </div>

                      
                      </>)

                    })
                   }

                    
                    </div>
                  </>}

              </ListGroup>
              </Card.Body>
          </Card>
          }

         {/*Salary or salary + Business*/}
         
          {(_.get(loanFormDetails,"profession_type_id")  == 1 || [1,3].indexOf(_.get(loanFormDetails,"income_type_id"))>-1)&& <Card className="mb-4 subscriberDetails">
             <Card.Body className="bg-white">
              <ListGroup variant="flush">
                <div class="row">
                <HBar label="Salary Details" />
                <div class="col-md-2"><ListGroup.Item>
                    <strong>Company Name:</strong><br /> <span>{_.get(loanFormDetails,"companyName")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Total Experience:</strong><br /> <span>{_.get(loanFormDetails,"totalExperience")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Years In Current Organization:</strong><br /> <span>{_.get(loanFormDetails,"present_organization_years")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Work Location:</strong><br /> <span>{_.get(loanFormDetails,"workLocation")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Gross Salary:</strong><br /> <span>{_.get(loanFormDetails,"grossSalary")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Net Salary:</strong><br /> <span>{_.get(loanFormDetails,"netSalary")}</span>
                    </ListGroup.Item>
                  </div>
                  

                </div>
              </ListGroup>
              </Card.Body>
          </Card>
          }

        {/*Business OR salary + Business*/}
          {([2,3].indexOf(_.get(loanFormDetails,"income_type_id"))>-1)&&<Card className="mb-4 subscriberDetails">
             <Card.Body className="bg-white">
              <ListGroup variant="flush">
                <div class="row">
                  <HBar label="Business Details"/>
                  
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Company Name:</strong><br /> <span>{_.get(loanFormDetails,"companyName")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Designation:</strong><br /> <span>{_.get(loanFormDetails,"designation")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Num Of Years:</strong><br /> <span>{_.get(loanFormDetails,"number_of_years")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Location:</strong><br /> <span>{_.get(loanFormDetails,"location")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Last Turnover Year:</strong><br /> <span>{_.get(loanFormDetails,"last_turnover_year")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Last Turnover Amount:</strong><br /> <span>{_.get(loanFormDetails,"last_year_turnover_amount")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Last Year Income ITR:</strong><br /> <span>{_.get(loanFormDetails,"last_year_itr")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Last Year ITR AMount:</strong><br /> <span>{_.get(loanFormDetails,"lastYearITRamount")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Present Turnover Year:</strong><br /> <span>{_.get(loanFormDetails,"current_turnover_year")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Present Turnover Amount:</strong><br /> <span>{_.get(loanFormDetails,"current_year_turnover_amount")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Present Year Income ITR:</strong><br /> <span>{_.get(loanFormDetails,"current_year_itr")}</span>
                    </ListGroup.Item>
                  </div>

                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Present Year ITR Amount:</strong><br /> <span>{_.get(loanFormDetails,"presentYearITRamount")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-2"><ListGroup.Item>
                    <strong>Avg Income per Month:</strong><br /> <span>{_.get(loanFormDetails,"avg_income_per_month")}</span>
                    </ListGroup.Item>
                  </div>
                  
                  
                  

                </div>
              </ListGroup>
              </Card.Body>
          </Card>
          }

        </Col>
      </Row>
    </div>
  );
};

export default CustomerDetails;
